<template>
  <div class="border shadow bg-gray-100 hover:bg-gray-200 py-6 px-8">
    <div class="flex justify-start">
      <p class="text-lg">
        <i class="fas fa-bell mr-2"></i>
        <span class="text-gray-600 font-medium">{{ notice.date }}</span></p>
    </div>
    <div class="space-y-4">
      <h1 class="text-4xl text-gray-800 font-semibold">{{ notice.title }}</h1>
      <p class="text-justify">{{ notice.description }}</p>
    </div>
    <div class="flex justify-end">
      <div>
        <i class="fas fa-paper-plane mr-2"></i>
        <a :href="`/static/pdf/library/notices/${notice.file}.pdf`" class="hover:text-pink-600 hover:underline"
           target="_blank">View Document</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Notices",
  props: {
    notice: Object
  }
}
</script>

<style scoped>

</style>